export default "<div class=\"top_section\">\r\n    <div class=\"container-fluid\">\r\n    </div>\r\n</div>\r\n"